<template>
  <ak-basic-container>
    <ak-box class="pb-none">
      <h4 class="color-grey mb-small">Withdrawal Requests</h4>
    </ak-box>
    <ak-box class="pt-none">
      <ak-tabs v-model="activeTab">
        <ak-tab-item label="Requests">
          <ak-requests-table
            :account="activeAccount._id"
            :agency="activeAgency._id"
            :user="userProfile"
          />
        </ak-tab-item>
        <ak-tab-item label="Approved">
          <ak-approved-table
            :account="activeAccount._id"
            :agency="activeAgency._id"
            :user="userProfile"
            @set-tab="activeTab = 0"
          />
        </ak-tab-item>
        <ak-tab-item label="Rejected">
          <ak-rejected-table
            :account="activeAccount._id"
            :agency="activeAgency._id"
            :user="userProfile"
          />
        </ak-tab-item>
        <ak-tab-item label="Processed">
          <ak-processed-table
            :account="activeAccount._id"
            :agency="activeAgency._id"
          />
        </ak-tab-item>
      </ak-tabs>
    </ak-box>
  </ak-basic-container>
</template>

<script>
import { ref, defineComponent } from 'vue'
import BasicContainer from '../containers/BasicContainer.vue'
import Box from '@akerolabs/akero-vue/src/components/box/Box.vue'
import Tabs from '@akerolabs/akero-vue/src/components/tabs/Tabs.vue'
import TabItem from '@akerolabs/akero-vue/src/components/tabs/TabItem.vue'
import RequestsTable from './tabs/RequestsTable.vue'
import ApprovedTable from './tabs/ApprovedTable.vue'
import RejectedTable from './tabs/RejectedTable.vue'
import ProcessedTable from './tabs/ProcessedTable.vue'
import { getTab } from './utils'
export default defineComponent({
  name: 'AkSurveyWithdrawalsList',
  components: {
    [BasicContainer.name]: BasicContainer,
    [Box.name]: Box,
    [Tabs.name]: Tabs,
    [TabItem.name]: TabItem,
    [RequestsTable.name]: RequestsTable,
    [ApprovedTable.name]: ApprovedTable,
    [RejectedTable.name]: RejectedTable,
    [ProcessedTable.name]: ProcessedTable,
  },
  inheritAttrs: false,
  props: {
    /**
     * @type {Object}
     * @description The active account (drilled in or users)
     */
    activeAccount: {
      default: () => ({}),
      type: Object,
    },

    /**
     * @type {Object}
     * @description The active agency (drilled in or users)
     */
    activeAgency: {
      default: () => ({}),
      type: Object,
    },

    /**
     * @type {Object}
     * @description The users profile data
     */
    userProfile: {
      default: () => ({}),
      type: Object,
    },
  },
  setup() {
    const activeTab = ref(getTab())
    return {
      activeTab,
    }
  },
})
</script>
